import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { CircularProgress, Box } from '@mui/material';

const LoadingSpinner = () => (
  <Box 
    display="flex" 
    justifyContent="center" 
    alignItems="center" 
    minHeight="100vh"
  >
    <CircularProgress />
  </Box>
);

export const PrivateRoute = ({ children, allowedRoles = [] }) => {
  const { user, loading, isAuthenticated } = useAuth();
  const location = useLocation();

  // Mostrar spinner mientras se carga
  if (loading) {
    return <LoadingSpinner />;
  }

  // Verificar autenticación
  if (!isAuthenticated()) {
    console.log('🚫 [ProtectedRoute] Usuario no autenticado, redirigiendo a login');
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Verificar roles si es necesario
  if (allowedRoles.length > 0 && !allowedRoles.includes(user.rol)) {
    console.log('⚠️ [ProtectedRoute] Usuario no tiene el rol requerido, redirigiendo a dashboard');
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export const AdminRoute = ({ children }) => {
  const { user, loading, isAuthenticated } = useAuth();
  const location = useLocation();

  if (loading) {
    return <LoadingSpinner />;
  }

  if (!isAuthenticated()) {
    console.log('🚫 [AdminRoute] Usuario no autenticado, redirigiendo a login');
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (user.rol !== 'admin') {
    console.log('⚠️ [AdminRoute] Usuario no es admin, redirigiendo a dashboard');
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default PrivateRoute; 